import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    detailChannel = new Subject();
    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    typeChannel = new Subject();
    signatoriesChannel = new Subject();
    approvalChannel = new Subject();
    cancelAdminChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.detailChannel.next({ status: apiResponse.INITIAL })
        this.rowtableChannel.next({ status: apiResponse.INITIAL })
        this.inactiveChannel.next({ status: apiResponse.INITIAL })
        this.signatoriesChannel.next({ status: apiResponse.INITIAL })
        this.typeChannel.next({status: apiResponse.INITIAL })
        this.approvalChannel.next({ status: apiResponse.INITIAL })
        this.cancelAdminChannel.next({ status: apiResponse.INITIAL })
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }


    fetchTypeList = async (query) => {
        try {
            this.typeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchTypeList(query).then((result) => {
                this.typeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.typeChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchSignatoriesList = async (query) => {
        try {
            this.signatoriesChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSignatoriesList(query).then((result) => {
                this.signatoriesChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.signatoriesChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchApproval = async (query) => {
        try {
            this.approvalChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchApproval(query).then((result) => {
                this.approvalChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approvalChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    
    fetchCancelAdmin = async (query) => {
        try {
            this.cancelAdminChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCancelAdmin(query).then((result) => {
                this.cancelAdminChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.cancelAdminChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

}

export default IndexBloc